import { Configuration, ApiConfigOptions } from '@sg/api/base-api-lib';

export interface InstrumentsManagerApiConfigOptions extends ApiConfigOptions {}
export class InstrumentsManagerApiConfig extends Configuration {
  constructor(configOptions?: InstrumentsManagerApiConfigOptions) {
    super({ ...{}, ...(configOptions || {}) });
  }
}
